import { useState } from "react";
import { Sunrise, ListChecks, CheckCircle2 } from "lucide-react";
import { MomentShell, SaveButton } from "../day/MomentShell";
import { SHORT_LABEL } from "./labels";

function ShortVersion({ text, testid }) {
  return (
    <span className="mt-2 block rounded-lg border-l-2 border-[#D4AF37]/60 bg-[#18181C] px-3 py-2 text-sm text-[#B4B4BC]" data-testid={testid}>
      <span className="italic">{SHORT_LABEL}</span> {text}
    </span>
  );
}

function ChoiceCard({ c, n, active, onPick }) {
  return (
    <button type="button" onClick={onPick} aria-pressed={active} data-testid={`c2g-choice-${c.choice_id}`}
      className={`w-full rounded-xl border-2 p-4 text-left transition-colors ${active ? "border-[#D4AF37] bg-[#D4AF37]/10" : "border-[#27272A] bg-[#0D0D0F] hover:border-[#3F3F46]"}`}>
      <span className="flex items-center justify-between">
        <span className="text-sm font-bold uppercase tracking-wider text-[#E5C158]">Passo {n}</span>
        {active && <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#F4F4F5]" data-testid={`c2g-choice-${c.choice_id}-selected`}><CheckCircle2 size={15} /> Selezionato</span>}
      </span>
      <span className="a2g-read mt-1.5 block text-base text-[#F4F4F5]">{c.text}</span>
      <ShortVersion text={c.minimum_version} />
    </button>
  );
}

export function MorningChoice({ m, rec, editable, time, onAction }) {
  const selected = rec?.selectedStep?.choiceId || null;
  const [pick, setPick] = useState(selected);
  const [changing, setChanging] = useState(!selected);
  const [saving, setSaving] = useState(false);
  const num = (id) => Number(String(id).slice(1));

  const save = async () => {
    if (selected && pick !== selected && !window.confirm("Cambiando passo, le risposte di Mezzogiorno e la riduzione del passo precedente vengono azzerate. Continuare?")) return;
    setSaving(true);
    const ok = await onAction({ action: "select", choice_id: pick });
    setSaving(false);
    if (ok) setChanging(false);
  };

  return (
    <>
      <MomentShell icon={Sunrise} label="Mattino" time={time} title={m.title} text={m.body} done={!!selected} index={0} testid="c2g-morning" />
      <MomentShell icon={ListChecks} label="Azione del giorno" title={m.choice_instruction} done={!!selected} index={1} testid="c2g-action">
        {selected && !changing ? (
          <div className="mt-4 rounded-xl border-2 border-[#D4AF37] bg-[#0D0D0F] p-4" data-testid="c2g-morning-selected">
            <p className="text-sm font-bold uppercase tracking-wider text-[#E5C158]">Passo {num(selected)} · scelto</p>
            <p className="a2g-read mt-1 text-base font-medium text-[#F4F4F5]" data-testid="c2g-selected-step">{rec.selectedStep.text}</p>
            <ShortVersion text={rec.selectedStep.minimumText} testid="c2g-selected-minimum" />
            {editable && (
              <button type="button" onClick={() => setChanging(true)} data-testid="c2g-change-step" className="mt-3 text-sm font-semibold text-[#D4AF37] underline-offset-4 hover:underline">Cambia passo</button>
            )}
          </div>
        ) : editable ? (
          <>
            <div className="mt-4 space-y-2.5" data-testid="c2g-choice-list">
              {m.choices.map((c) => <ChoiceCard key={c.choice_id} c={c} n={num(c.choice_id)} active={pick === c.choice_id} onPick={() => setPick(c.choice_id)} />)}
            </div>
            <SaveButton onClick={save} disabled={!pick || pick === selected} saving={saving} label="Scegli questo passo" testid="c2g-select-button" />
            {selected && <button type="button" onClick={() => { setPick(selected); setChanging(false); }} data-testid="c2g-change-cancel" className="mt-2 w-full text-sm text-[#8A8E96] underline">Annulla</button>}
          </>
        ) : (
          <p className="a2g-read mt-3 text-base text-[#8A8E96]" data-testid="c2g-morning-none">In questo giorno non è stato scelto un passo.</p>
        )}
      </MomentShell>
    </>
  );
}
